import { use } from "react";
import { userTypes } from "../actions/user";

const initialState = {
  isLoading: false,
  rolesLoading: false,
  currentModal: false,
  isDownloaded: "",
  isInitialLoad: true,
  users:[],
  userList: [],
  rolesList: [],
  error: null,
  totalUserCount: 0,
  filters: {
    searchName: [],
    searchFirstName: [],
    searchLastName: [],
    searchEmail: [],
    roleFilter: [],
    organizationFilter: [],
    sort: [
      {
        field: "createdon",
        order: "desc",
      },
    ],
    limit: 10,
    pageNo: 0,
    querytotalcount: true,
    selection: "",
  },
};

const userReducer = (state = initialState, action) => {
    switch (action.type) {
      case userTypes.DOWNLOAD_REQUEST:
        return {
          ...state,
          isDownloaded: "Downloading....",
          isLoading: true,
        };
      case userTypes.DOWNLOAD_SUCCESS:
        return {
          ...state,
          isLoading: false,
          isDownloaded: "Downloaded",
        };
      case userTypes.DOWNLOAD_FAILURE:
        return {
          ...state,
          isLoading: false,
          isDownloaded: "Something Went Wrong",
          error: action.payload,
        };
      case userTypes.FETCH_USER_SUCCESS:
        return {
          ...state,
          users: action.payload,
        }
      case userTypes.FETCH_USER_ERROR:
        return {
          ...state,
          error: action.payload,
        }
      case userTypes.SET_CURRENT_MODAL:
        return {
          ...state,
          currentModal: action.payload,
        }
      case userTypes.FETCH_USER_LIST:
        return {
          ...state,
          isLoading: true,
        }
      case userTypes.FETCH_USER_LIST_SUCCESS:
        return {
          ...state,
          isLoading: false,
          userList: action.payload,
          totalUserCount: action.totalUserCount,
        }
      case userTypes.FETCH_USER_LIST_ERROR:
        return {
          ...state,
          isLoading: false,
          error: action.payload,
        }
      case userTypes.FETCH_ROLES_REQUEST:
        return { ...state, rolesLoading: true, error: null };
      case userTypes.FETCH_ROLES_SUCCESS:
        return { ...state, rolesLoading: false, rolesList: action.payload };
      case userTypes.FETCH_ROLES_FAILURE:
        return { ...state, rolesLoading: false, error: action.payload };
      case userTypes.UPDATE_PAGINATION_REQUEST:
        return {
          ...state,
          filters: {
            ...state.filters,
            ...action.payload,
          },
        };
      case userTypes.RESET_FILTERS:
      return {
        ...state,
        filters: initialState.filters,
      };
      default:
        return state;
    }
  };
  
  export default userReducer;